import { Pipe, PipeTransform } from '@angular/core';

@Pipe({name: 'removeZeros'})
export class RemoveZerosPipe implements PipeTransform {
  
  transform(value: string, args: string[]): any {
    if (!value) return value;

    let x: number = +value;

    if (x < 0.00001 && x > -0.00001){
      return '';
    } else {
      return value;
    }
  }
}


// WEBPACK FOOTER //
// ./src/pipes/removeZeros.pipe.ts